import { Box, Divider, Group, Stack } from "@mantine/core"
import { PageHeader } from "src/components/ui/PageHeader"
import { PageLayout } from "src/components/ui/PageLayout"
import { useAppState } from "src/state"
import { SuperAdminThreadMessages } from "./messages/SuperAdminThreadMessages"
import { SuperAdminThreadPreview } from "src/components/superadmin/threads/SuperAdminThreadPreview"

export function SuperAdminThread() {

    const { currentItem } = useAppState(state => state.threads)

    return (
        <PageLayout
            header={
                <PageHeader
                    title={`${currentItem?.id}`}
                    renderAction={
                        <Group gap="sm">

                        </Group>
                    }
                />
            }
        >

            <Stack gap="sm">
                <SuperAdminThreadPreview />
                <Divider
                    my="0"
                    variant="dashed"
                    labelPosition="left"
                    label={<Box ml={5}>Messages</Box>}
                />
                <SuperAdminThreadMessages />
            </Stack>

        </PageLayout>
    )

}